import * as types from '../../../constants/ActionNameConstants';

// Read Notification
export const ReadNotificationRequest = (payload) => {
  return {
    type: types.READ_NOTIFICATION_REQUEST,
    payload,
  };
};

export const ReadNotificationSuccess = (payload) => ({
  type: types.READ_NOTIFICATION_SUCCESS,
  payload,
});

export const ReadNotificationFailure = (error) => ({
  type: types.READ_NOTIFICATION_FAILED,
  error,
});
